import axios from 'axios';
import { header } from './header.encry';

const API_URL = process.env.REACT_APP_PEGASUS_API_URL;

export const fetchOrders = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const res = await axios.get(`${API_URL}/internal-orders${query ? `?${query}` : ''}`, header());
  return res.data;
};

export const createOrder = async (data) => {
  const res = await axios.post(`${API_URL}/internal-orders`, data, header());
  return res.data;
};

export const updateStatus = async (id, status) => {
  const res = await axios.patch(`${API_URL}/internal-orders/${id}/status`, { status }, header());
  return res.data;
};

export const removeOrder = async (id) => {
  const res = await axios.delete(`${API_URL}/internal-orders/${id}`, header());
  return res.data;
};

export const fetchCounts = async () => {
  const res = await axios.get(`${API_URL}/internal-orders-counts`, header());
  return res.data;
};

export const orderCodeLookup = async (orderCodes = []) => {
  const res = await axios.post(`${API_URL}/orders/ordercode`, { orderCodes }, header());
  return res.data;
};

export const getOrderByCode = async (orderCode) => {
  const res = await axios.get(`${API_URL}/orders/code/${encodeURIComponent(orderCode)}`, header());
  return res.data;
};

export const createFromWoo = async (wooOrder, store_id = null) => {
  // Build an `order` object that respects the internal order keys while
  // preserving original Woo order under `woo_order`. Do not mutate input.
  const wo = JSON.parse(JSON.stringify(wooOrder || {}));

  const toIsoDate = (d) => {
    try { return (new Date(d)).toISOString(); } catch (e) { return new Date().toISOString(); }
  };

  const formatDateDDMMYYYY = (d) => {
    try {
      const dt = new Date(d);
      const dd = String(dt.getDate()).padStart(2,'0');
      const mm = String(dt.getMonth()+1).padStart(2,'0');
      const yyyy = dt.getFullYear();
      return `${dd}/${mm}/${yyyy}`;
    } catch (e) { return '' }
  };

  const formatTime = (d) => {
    try { return new Date(d).toTimeString().split(' ')[0] + ' GMT' + (new Date(d).getTimezoneOffset()/-60); } catch (e) { return '' }
  };

  const products = Array.isArray(wo.line_items) ? wo.line_items.map(li => {
    const meta = Array.isArray(li.meta_data) ? li.meta_data : [];
    // Only include meta entries that look like product options (have a display_key or non-private key)
    const options = meta
      .filter(m => {
        if (!m) return false;
        const name = String(m.display_key ?? m.key ?? '');
        // Exclude meta entries whose option name starts with '_' (private/internal)
        return name && !name.startsWith('_');
      })
      .map(m => {
        const name = String(m.display_key ?? m.key ?? '');
        const rawVal = (m.display_value !== undefined && m.display_value !== null) ? m.display_value : (m.value !== undefined ? m.value : '');
        const valueStr = (typeof rawVal === 'object') ? JSON.stringify(rawVal) : String(rawVal);
        const value = valueStr == null ? '' : valueStr.trim();
        return {
          quantity: String(li.quantity || 1),
          title: `${name} : ${value}`,
          remote_option_id: String(m.id ?? m.meta_id ?? m.key ?? '')
        };
      })
      // remove options with empty value or meaningless JSON/strings
      .filter(o => o && o.title && o.title !== ' : ' && o.title.split(':')[1] && o.title.split(':')[1].trim() !== '' && o.title.split(':')[1].trim() !== '{}' && o.title.split(':')[1].trim() !== '[]' && o.title.split(':')[1].trim() !== 'null');

    return {
      title: li.name || '',
      urlImage: (li.image && li.image.src) || (li.image && li.img) || '',
      quantity: String(li.quantity || 1),
      price: String(li.price != null ? li.price : (li.total != null ? li.total : 0)),
      options: options,
    };
  }) : [];

  // Add fee_lines as products if they exist
  const feeProducts = Array.isArray(wo.fee_lines) ? wo.fee_lines.map(fee => {
    return {
      title: fee.name || 'Frais supplémentaire',
      urlImage: '',
      quantity: '1',
      price: String(fee.total != null ? fee.total : (fee.amount != null ? fee.amount : 0)),
      options: [],
      isFee: true, // Mark this as a fee product for identification purposes
    };
  }) : [];

  // Combine line items products and fee products
  const allProducts = [...products, ...feeProducts];

  const customerName = ((wo.shipping && ((wo.shipping.first_name || '') + ' ' + (wo.shipping.last_name || '')).trim()) || (wo.billing && ((wo.billing.first_name || '') + ' ' + (wo.billing.last_name || '')).trim()) || wo.customer_name || '');

  const orderObj = {
    productType: 'Site',
    products: allProducts,
    plateform_id: wo.plateform_id || null,
    store_id: store_id || wo.store_id || wo.store || '',
    orderCode: String(wo.number || wo.id || wo.order_number || ''),
    orderNumber: String(wo.number || wo.id || wo.order_number || ''),
    CustomerName: customerName,
    productsCount: String(allProducts.length || wo.line_items?.length || 0),
    orderTime: formatTime(wo.date_created || wo.created_at || Date.now()),
    orderStatus: 'accepted',
    ticketprinted: false,
    orderDate: formatDateDDMMYYYY(wo.date_created || wo.date_created_gmt || Date.now()),
    reference_products: [],
    createdAt: toIsoDate(wo.date_created || wo.created_at || Date.now()),
    updatedAt: toIsoDate(wo.date_modified || wo.updated_at || Date.now()),
    __v: 0
  };

  const payload = { woo_order: wo, order: orderObj };
  const res = await axios.post(`${API_URL}/orders/woo`, payload, header());
  return res.data;
};

export default { fetchOrders, createOrder, updateStatus, removeOrder, fetchCounts };
